import { Tier1PlannedAction } from '../../types/tier1Portfolio';

export const PLANNED_ACTION_LABEL: Record<Tier1PlannedAction, string> = {
  hold: 'Hold',
  open: 'Open',
  add: 'Add',
  trim: 'Trim',
  close: 'Close',
  pending_approval: 'Pending approval',
};

export const PLANNED_ACTION_CLASS: Record<Tier1PlannedAction, string> = {
  hold: 'bg-gray-100 text-gray-700 border-gray-200',
  open: 'bg-blue-50 text-blue-900 border-blue-200',
  add: 'bg-sky-50 text-sky-900 border-sky-200',
  trim: 'bg-amber-50 text-amber-900 border-amber-200',
  close: 'bg-orange-50 text-orange-900 border-orange-200',
  pending_approval: 'bg-violet-50 text-violet-900 border-violet-200',
};

export function formatRegistryStatus(status?: string): string {
  if (!status) return '—';
  return status.replace(/_/g, ' ').toLowerCase();
}
